export const isSelected = (id, selectedRows) => selectedRows.indexOf(id) !== -1;
